import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-content" }
const _hoisted_2 = { class: "pwd-input-wrap" }
const _hoisted_3 = { class: "btn-wrap" }
const _hoisted_4 = { class: "input-group" }
const _hoisted_5 = { class: "country-code" }
const _hoisted_6 = { class: "input-group" }
const _hoisted_7 = { class: "input-group" }
const _hoisted_8 = { class: "input-group" }
const _hoisted_9 = { class: "input-group" }
const _hoisted_10 = { class: "forget-btn-wrap" }

import CustomTitleBar from "@/components/CustomTitleBar/index.vue";
import { ref, computed, onMounted } from "vue";
import { showToast } from 'vant';
import { useRouter } from 'vue-router';
import { sendSmsCode, getCaptcha } from '@/api/system';
import { resetPayPassword } from '@/api/wallet';


export default /*@__PURE__*/_defineComponent({
  __name: 'resetPwd',
  setup(__props) {

const router = useRouter();
// 密码设置相关
const currentStep = ref(1);
const oldPassword = ref("");
const password = ref("");
const confirmPassword = ref("");
const showKeyboard = ref(false);
const showForgetForm = ref(false);

// 忘记密码表单相关
const phoneAreaPrefix = ref('86');
const phoneNumber = ref('');
const newPassword = ref('');
const confirmNewPassword = ref('');
const verificationCode = ref('');
const cooldownTime = ref(0);
let timer: ReturnType<typeof setInterval> | null = null;

const formRef = ref();

// 计算按钮是否可用
const isValid = computed(() => {
  switch (currentStep.value) {
    case 1:
      return oldPassword.value.length === 6;
    case 2:
      return password.value.length === 6;
    case 3:
      return confirmPassword.value.length === 6;
    default:
      return false;
  }
});

// 密码输入相关方法
const onFocus = () => {
  showKeyboard.value = true;
};

const onBlur = () => {
  showKeyboard.value = false;
};

const onInput = (key: string) => {
  switch (currentStep.value) {
    case 1:
      if (oldPassword.value.length < 6) {
        oldPassword.value += key;
      }
      break;
    case 2:
      if (password.value.length < 6) {
        password.value += key;
      }
      break;
    case 3:
      if (confirmPassword.value.length < 6) {
        confirmPassword.value += key;
      }
      break;
  }
};

const onDelete = () => {
  switch (currentStep.value) {
    case 1:
      if (oldPassword.value.length > 0) {
        oldPassword.value = oldPassword.value.slice(0, -1);
      }
      break;
    case 2:
      if (password.value.length > 0) {
        password.value = password.value.slice(0, -1);
      }
      break;
    case 3:
      if (confirmPassword.value.length > 0) {
        confirmPassword.value = confirmPassword.value.slice(0, -1);
      }
      break;
  }
};

// 添加密码验证方法
const validateConfirmPassword = (value: string) => {
  return value === newPassword.value;
};

// 返回按钮处理
const handleBack = () => {
  showForgetForm.value = false;
  // 重置表单数据
  phoneNumber.value = '';
  newPassword.value = '';
  confirmNewPassword.value = '';
  verificationCode.value = '';
  if (timer) {
    clearInterval(timer);
    timer = null;
  }
  cooldownTime.value = 0;
};

// 图形验证码相关
const imageCode = ref('');
const captchaUrl = ref('');

// 获取图形验证码
const refreshCaptcha = async () => {
  try {
    const res = await getCaptcha();
    captchaUrl.value = URL.createObjectURL(res);
  } catch (error) {
    console.log('获取图形验证码失败', error);
  }
};

// 在组件挂载时获取图形验证码
onMounted(() => {
  refreshCaptcha();
});

// 修改发送验证码前校验
const sendVerificationCode = async () => {
  try {
    // 校验手机号和图形验证码
    await formRef.value?.validate(['phoneNumber', 'imageCode']);

    const res = await sendSmsCode({
      captcha: imageCode.value,
      phoneAreaPrefix: phoneAreaPrefix.value,
      phoneNumber: phoneNumber.value,
      type: 3
    });

    if (res.code === 200) {
      showToast('发送成功');
      cooldownTime.value = 60;
      timer = setInterval(() => {
        cooldownTime.value--;
        if (cooldownTime.value <= 0 && timer) {
          clearInterval(timer);
          timer = null;
        }
      }, 1000);
    } else {
      showToast(res.msg);
      // 刷新图形验证码
      refreshCaptcha();
    }
  } catch (error) {
    console.log('验证失败', error);
  }
};

// 提交表单
const handleForgetSubmit = async () => {
  try {
    await formRef.value?.validate();
    // TODO: 处理忘记密码提交逻辑
    const res = await resetPayPassword({
      captcha: verificationCode.value,
      newPassword: newPassword.value,
      phoneAreaPrefix: phoneAreaPrefix.value,
      phoneNumber: phoneNumber.value,
      type: 1,
    });
    if (res.code === 200) {
      showToast({
        type: 'success',
        message: '重置支付密码成功'
      });
      router.go(-1);
    } else {
      showToast(res.msg);
    }
  } catch (error) {
    console.log('表单验证失败', error);
  }
};

const handleNext = async () => {
  if (currentStep.value === 1) {
    // TODO: 验证原密码是否正确
    if (oldPassword.value.length === 6) {
      currentStep.value = 2;
      showKeyboard.value = false;
    }
  } else if (currentStep.value === 2) {
    if (password.value.length === 6) {
      currentStep.value = 3;
      showKeyboard.value = false;
    }
  } else {
    if (confirmPassword.value !== password.value) {
      showToast({
        type: 'fail',
        message: '两次输入的密码不一致'
      });
      confirmPassword.value = '';
      return;
    }

    try {
      const res = await resetPayPassword({
        newPassword: password.value,
        oldPassword: oldPassword.value,
        type: 0,
      });
      if (res.code === 200) {
        showToast({
          type: 'success',
          message: '重置支付密码成功'
        });
        router.go(-1);
      } else {
        showToast(res.msg);
      }
    } catch (error) {
      console.log('重置支付密码失败', error);
    }
  }
};

return (_ctx: any,_cache: any) => {
  const _component_van_password_input = _resolveComponent("van-password-input")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_number_keyboard = _resolveComponent("van-number-keyboard")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomTitleBar, {
      title: currentStep.value === 1 ? '设置支付密码' : '重置支付密码'
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      (!showForgetForm.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_2, [
              (currentStep.value === 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "tip-text" }, "请输入支付密码以验证身份", -1)),
                    _createVNode(_component_van_password_input, {
                      value: oldPassword.value,
                      focused: showKeyboard.value,
                      length: 6,
                      onFocus: onFocus
                    }, null, 8, ["value", "focused"])
                  ], 64))
                : _createCommentVNode("", true),
              (currentStep.value === 2)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "tip-text" }, "请设置支付密码，用于支付验证", -1)),
                    _createVNode(_component_van_password_input, {
                      value: password.value,
                      focused: showKeyboard.value,
                      length: 6,
                      onFocus: onFocus
                    }, null, 8, ["value", "focused"])
                  ], 64))
                : _createCommentVNode("", true),
              (currentStep.value === 3)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "tip-text" }, "请再次填写支付密码以确认", -1)),
                    _createVNode(_component_van_password_input, {
                      value: confirmPassword.value,
                      focused: showKeyboard.value,
                      length: 6,
                      onFocus: onFocus
                    }, null, 8, ["value", "focused"])
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_van_button, {
                type: "primary",
                round: "",
                onClick: handleNext,
                disabled: !isValid.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(currentStep.value === 1 ? '继续' : '确认'), 1)
                ]),
                _: 1
              }, 8, ["disabled"]),
              (currentStep.value === 1)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "forget-pwd",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (showForgetForm.value = true))
                  }, " 忘记密码 "))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_van_number_keyboard, {
              show: showKeyboard.value,
              onBlur: onBlur,
              onInput: onInput,
              onDelete: onDelete,
              maxlength: 6
            }, null, 8, ["show"])
          ], 64))
        : (_openBlock(), _createBlock(_component_van_form, {
            key: 1,
            onSubmit: handleForgetSubmit,
            ref_key: "formRef",
            ref: formRef
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_van_field, {
                  modelValue: phoneNumber.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((phoneNumber).value = $event)),
                  placeholder: "输入手机号",
                  border: false,
                  rules: [
            { required: true, message: '请输入手机号' },
            { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号' }
          ]
                }, {
                  label: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_SvgIcon, { name: "phone" }),
                      _createElementVNode("span", null, "+" + _toDisplayString(phoneAreaPrefix.value), 1),
                      _createVNode(_component_van_icon, {
                        name: "arrow-down",
                        size: "14",
                        color: "#666666"
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_van_field, {
                  modelValue: newPassword.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newPassword).value = $event)),
                  type: "password",
                  placeholder: "输入新的六位数支付密码",
                  border: false,
                  maxlength: "6",
                  rules: [{ required: true, message: '请输入支付密码' }, { pattern: /^\d{6}$/, message: '请输入6位数字密码' }]
                }, {
                  label: _withCtx(() => [
                    _createVNode(_component_SvgIcon, { name: "pwd" })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_van_field, {
                  modelValue: confirmNewPassword.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((confirmNewPassword).value = $event)),
                  type: "password",
                  placeholder: "确认新的六位数支付密码",
                  border: false,
                  maxlength: "6",
                  rules: [
              { required: true, message: '请再次输入支付密码' },
              { validator: validateConfirmPassword, message: '两次输入的密码不一致' }
            ]
                }, {
                  label: _withCtx(() => [
                    _createVNode(_component_SvgIcon, { name: "pwd" })
                  ]),
                  _: 1
                }, 8, ["modelValue", "rules"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_van_field, {
                  modelValue: imageCode.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((imageCode).value = $event)),
                  placeholder: "输入图形验证码",
                  border: false,
                  rules: [{ required: true, message: '请输入图形验证码' }]
                }, {
                  label: _withCtx(() => [
                    _createVNode(_component_SvgIcon, { name: "code" })
                  ]),
                  "right-icon": _withCtx(() => [
                    _createVNode(_component_el_image, {
                      class: "captcha-img",
                      src: captchaUrl.value,
                      onClick: refreshCaptcha,
                      alt: "验证码"
                    }, null, 8, ["src"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_van_field, {
                  modelValue: verificationCode.value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((verificationCode).value = $event)),
                  placeholder: "输入验证码",
                  border: false,
                  rules: [{ required: true, message: '请输入验证码' }]
                }, {
                  label: _withCtx(() => [
                    _createVNode(_component_SvgIcon, { name: "code2" })
                  ]),
                  "right-icon": _withCtx(() => [
                    _createVNode(_component_van_button, {
                      size: "small",
                      plain: "",
                      type: "primary",
                      onClick: sendVerificationCode,
                      disabled: cooldownTime.value > 0
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(cooldownTime.value > 0 ? `${cooldownTime.value}s` : '获取验证码'), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_van_button, {
                  type: "primary",
                  block: "",
                  round: "",
                  "native-type": "submit",
                  onClick: handleForgetSubmit
                }, {
                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                    _createTextVNode("确认")
                  ])),
                  _: 1
                }),
                _createElementVNode("div", {
                  class: "back-btn",
                  onClick: handleBack
                }, "返回")
              ])
            ]),
            _: 1
          }, 512))
    ])
  ], 64))
}
}

})